import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { loadConfig } from './lib/config';
import './styles.css';

/**
 * Configuration is resolved before the first render so no component has to
 * handle a half-configured app.
 */
loadConfig()
  .then(() => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <BrowserRouter>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </BrowserRouter>
      </StrictMode>,
    );
  })
  .catch((error: unknown) => {
    const root = document.getElementById('root');
    if (root) {
      root.textContent = `Could not load application configuration: ${
        error instanceof Error ? error.message : String(error)
      }`;
    }
  });
